module.exports = __webpack_public_path__ + "static/media/flag_cn_icon.cf75dc14.png";